import { SET_MAP_DIMENSIONS } from '../actions/types';
import initialState from '../initialState';

export default (state = initialState.mapDimensions, action) => {
  switch (action.type) {
    case SET_MAP_DIMENSIONS:
      return {
        ...state,
        [action.payload.pathSpaceId]: action.payload.dimensions,
      };
    default:
      return state;
  }
};
